<template>
  <div class=" fa">
    <div :class="zhuce_box_class">
      <div class="login_box">
        <div class="zhuce">{{ shopZhuce }}</div>
        <!-- 用户名 -->
        <el-form :rules="zhuceFormRules" ref="zhuceFormRef" label-width="120px" class="login_form" :model="zhuceForm">
          <!-- 商店名称 -->
          <el-form-item prop="mch_name" label="店铺名称">
            <el-input v-model="zhuceForm.mch_name" placeholder="输入店铺名称:"></el-input>
          </el-form-item>
          <!-- 微信openid -->
          <!-- <el-form-item prop="wx_open_id" label="微信id">
            <el-input v-model="zhuceForm.wx_open_id" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <img height="250px" :src="imgurl" alt="" />
          </el-form-item> -->
          <el-row :gutter="10">
            <el-col :span="19">
              <el-form-item prop="wx_open_id" label="微信id">
                <el-input v-model="zhuceForm.wx_open_id" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-popover placement="right" v-model="visible" trigger="manual">
                <img :height="img_height" :src="imgurl" alt="" />
                <a class="a-bind-wx" href="javaScript:;" slot="reference" @click="bindForWX">
                  绑定微信</a>
              </el-popover>
            </el-col>
          </el-row>

          <!-- 按钮部分 -->
          <el-form-item class="btns">
            <el-button type="warning" @click="Back">返回</el-button>
            <el-button type="primary" @click="submit">立即注册</el-button>
            <el-button type="info" @click="chongzhi">重置信息</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
// const axios = require("axios");
export default {
  data() {
    return {
      // zhuce_box_class
      zhuce_box_class: "",
      error_text: "",
      a: true,
      visible: false,
      shopZhuce: "店铺注册",
      zhuceForm: {
        mch_name: "",
        wx_open_id: ""
      },
      // 图片高度
      img_height: "",
      // 图片地址
      imgurl: "",
      Key32: "",
      nonce_str: this.getKey(16, 62),
      // 这是表单的验证规则对象
      zhuceFormRules: {
        // 验证密码是否合法
        wx_open_id: [
          // { validator: validatePass, required: true, trigger: "blur" }
          { required: true, message: "请绑定微信", trigger: "blur" }
        ],
        mch_name:
          // [{validator:validatePass2,trigger:'blur'}],
          [
            {
              min: 1,
              max: 16,
              message: "长度在 1 到 16 个字符",
              trigger: "blur"
            },
            { required: true, message: "请输入店铺名称", trigger: "blur" }
          ],
        sub_name: [
          { required: true, message: "请输入店铺简称", trigger: "blur" },
          { min: 1, max: 16, message: "应为 1 到 16 个字符", trigger: "blur" }
        ]
        // key: [{ required: true, message: "请输入密钥", trigger: "blur" }]
      },
      access_token: "",
      timer1: ""
    };
  },
  async created() {
  },
  beforeMount() {
    var resolution = window.screen.height * window.screen.width;
    this.img_height = 300 * (resolution / (864 * 1536));
    console.log(this.img_height);
    if (resolution <= 700 * 900) {
      this.zhuce_box_class = "zhuce-box-samall";
    }
    if (resolution > 700 * 900 && resolution < 1400 * 900) {
      this.zhuce_box_class = "zhuce-box-middle ";
    }
    if (resolution > 1400 * 900) {
      this.zhuce_box_class = "zhuce-box-large";
    }
  },
  beforeDestroy() {
    this.timer1 = setTimeout(() => {
      console.log("zhuce销毁前的狗子");
      window.sessionStorage.removeItem("url_zhuce");
    }, 30000);
  },
  methods: {
    submit() {
      for (var i in this.zhuceForm) {
        // 遍历对象判断是否有空值
        if (!this.zhuceForm[i]) {
          this.$message.error("信息不完整");
          return;
        }
      }
      this.$confirm("确定要绑定该微信吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var objectB = {
            mch_name: this.zhuceForm.mch_name,
            wx_open_id: this.zhuceForm.wx_open_id,
            nonce_str: this.nonce_str
          };
          var sign = this.getSign(objectB);
          console.log(sign);
          const result = await this.$post(
            this.$url + "merchant/create",
            {
              sign: sign,
              nonce_str: this.nonce_str,
              mch_name: this.zhuceForm.mch_name,
              wx_open_id: await this.encrypt(this.zhuceForm.wx_open_id)
            }
          );
          console.log(result);
          if (
            result.data.return_code === "SUCCESS" &&
            result.data.result_code === "SUCCESS" &&
            result.data.merchant_id
          ) {
            this.successMessage("注册成功");
            this.$router.push({
              name: "login"
            });
          } else if (
            result.data.return_code === "SUCCESS" &&
            result.data.result_code === "FAIL" &&
            result.data.result_msg === "账号需要绑定OPENID"
          ) {
            this.$message({
              message: "该微信未绑定账号请用已经绑定账号的微信注册店铺",
              duration: 5000,
              type: "warning"
            });
          } else if (
            result.data.return_code === "SUCCESS" &&
            result.data.result_code === "FAIL" &&
            result.data.result_msg === "商户名称已经存在"
          ) {
            this.warnMessage("店铺名称已经存在");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消请重新绑定"
          });
        });
    },
    chongzhi() {
      this.$refs.zhuceFormRef.resetFields();
    },
    // 判断账号是否重复
    Back() {
      this.$router.push("login");
    },
    async bindForWX() {
      console.log(this.Key32);
      // 获取二维码图片
      this.Key32 = this.getKey();
      var { data: res } = await this.getUrl(this.Key32);
      if (res === "request is too requently, please later try again") {
        this.imgurl = window.sessionStorage.getItem("url_zhuce");
      } else {
        window.sessionStorage.setItem("url_zhuce", res);
        this.imgurl = res;
      }

      this.visible = !this.visible;
      // 发送请求
      var data = await this.getOpenId(this.Key32);
      console.log(data);
      if (data.data && data.data.length === 28) {
        this.zhuceForm.wx_open_id = data.data
        console.log(data.data);
        this.visible = false;
      } else if (!this.zhuce_form.wx_open_id && data.data == null) {
        this.warnMessage("请求超时，请稍后再试");
        this.visible = false;
      }
    }
  }
};
</script>
<style scoped>
.fa {
  height: 100%;
  background: url(../assets/pic/0001.jpg);
  background-position: center;
  background-attachment: fixed;
  background-size: 105% auto;
}

.zhuce {
  color: dimgrey;
  text-align: center;
  font-size: 30px;
  margin-top: 20px;
}

.login_form {
  position: absolute;
  top: 80px;
  width: 100%;
  padding: 0 25px;
  box-sizing: border-box;
}

.btns {
  display: flex;
  justify-content: center;
  margin-left: -88px;
}

.zhuce-box-large {
  width: 600px;
  height: 280px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.3, 1.3);
}

.zhuce-box-middle {
  width: 600px;
  height: 280px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.zhuce-box-samall {
  width: 600px;
  height: 280px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8, 0.8);
}

/**/
.a-bind-wx {
  font-size: 20px;
  margin: 20px 0 0 20px;
  color: rgb(14, 152, 233);
  text-decoration: none;
  line-height: 2;
}

.a-bind-wx:hover {
  text-decoration: underline;
}
</style>
